<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="cargo"/>
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <p class="indextitle">Nova Correção</p>
              <div class="tile is-child" v-if="redacao.id.length == 0">
                <p class="paragrafo-redacao">
                  <strong>A redação esta carregando, aguarde por favor...</strong>
                </p>
              </div>
              <div class="tile is-child" v-else-if="redacao.id.length > 0">
                <p class="paragrafo-redacao">
                  <strong>Nº da Redação:</strong>
                  {{ redacao.numero }}
                  <br />
                  <strong>Aluno:</strong>
                  {{ redacao.aluno.name }}
                  <strong>Turma:</strong>
                  {{ redacao.aluno.nomeTurma }}
                  <strong>Escola:</strong>
                  {{ redacao.escola }}
                  <br />
                  <strong>Proposta:</strong>
                  <a v-bind:href="redacao.proposta_url" target="_blank"> {{ redacao.proposta }}</a>
                </p>

                <div class="control-rec">
                  <b-button v-on:click="RecordStart" id="btn-start-recording">
                    <span class="icon-rec-gravacao fas fa-record-vinyl"></span>Iniciar Gravação
                  </b-button>
                  <b-button v-on:click="RecordStop" id="btn-stop-recording" disabled>
                    <span class="icon-stop-gravacao fas fa-stop"></span> Parar Gravação
                  </b-button>
                  <b-button @click="loadRedacao">
                    <span class="icon-restart"></span> Carregar Redação
                  </b-button>
                </div>
                <tui-image-editor ref="tuiImageEditor" :options="options"></tui-image-editor>

                <div class="tile">
                  <div class>
                    <div class id>
                      <section id="correcao-dashboard" class="column">
                        <section id="entity-content">
                          <CorrigirForm
                            :correcao="correcao"
                            :redacao="redacao"
                            :progress="percentProgress"
                            @formSubmit="CreateCorrecao"
                            buttom="Enviar Correção"
                          />
                        </section>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <internfooter />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import store from "@/store";
import CorrecaoService from "@/services/CorrecaoService";
import RedacaoService from "@/services/RedacaoService";

//import Record from "@/components/CorretorView/Corrigir/Record";
import Record from "@/views/Redacao/Record";

//import CorrigirForm from "@/components/CorretorView/Corrigir/Form";
import CorrigirForm from "@/components/Forms/RedacaoCorrigir";

import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";

import { ImageEditor } from "@toast-ui/vue-image-editor";
import editorTheme from "@/editor/theme";
import editorLocale from "@/editor/locale";
import "tui-image-editor/dist/tui-image-editor.min.css";
import "tui-color-picker/dist/tui-color-picker.min.css";
import "tui-image-editor/dist/svg/icon-a.svg";
import "tui-image-editor/dist/svg/icon-b.svg";
import "tui-image-editor/dist/svg/icon-c.svg";
import "tui-image-editor/dist/svg/icon-d.svg";

export default {
  name: "correcaoNew",
  data() {
    return {
      corrigindo: false,

      redacao: {
        feedback: "",
        aluno_id: "",
        id: "",
        numero: "",
        proposta_id: "",
        url: ""
      },

      correcao: {
        id: "",
        video: "",
        principal: "1",
        notas: {},
        nota_final: "",
        comentario: "",
        redacao_id: "",
        corretor_id: store.getters.cargo_id
      },

      videoblob: "",
      url: "",
      percentProgress: 0,

      useDefaultUI: true,
      options: {
        // for options prop
        includeUI: {
          // loading a blank image so we can use the editor
          loadImage: {
            path:
              "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
            name: "Blank",
            crossOrigin: "anonymous"
          },
          theme: editorTheme,
          locale: editorLocale,
          menu: ["text", "draw", "rotate"],
          initMenu: "text",
          uiSize: {
            width: "100%",
            height: "100vh"
          },
          menuBarPosition: "top"
        },
        selectionStyle: {
          cornerSize: 20,
          rotatingPointOffset: 70
        },
        cssMaxWidth: "100%",
        cssMaxHeight: "100%",
        usageStatistics: false
      },
      editorMaxSizePercentage: 0.85,
      carregandoRedacao: false,
      cargo: store.getters.cargo
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    "tui-image-editor": ImageEditor,
    CorrigirForm: CorrigirForm,
    sidebar: sidebar
  },
  props: [],
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    scrollHandler() {
      let pageYOffset = window.pageYOffset;

      let topMenu = 230 - pageYOffset;
      let menus = document.querySelector("ul.tui-image-editor-menu");
      if (pageYOffset <= 159) {
        menus.style.top = topMenu + "px";
      } else {
        menus.style.top = "71px";
      }

      let topSubMenu = 239 - pageYOffset;
      let subMenus = document.querySelectorAll("ul.tui-image-editor-submenu-item");
      for (let i = 0; i < subMenus.length; i++) {
        if (pageYOffset <= 159) {
          subMenus[i].style.top = topSubMenu + "px";
        } else {
          subMenus[i].style.top = "80px";
        }
      }

      let topNotas = 210 - pageYOffset;
      let notas = document.querySelector("section#correcao-dashboard");
      if (pageYOffset <= 155) {
        notas.style.top = topNotas + "px";
      } else {
        notas.style.top = "55px";
      }
    },
    loadRedacao() {
      this.carregandoRedacao = true;
      this.$refs.tuiImageEditor
        .invoke("loadImageFromURL", this.redacao.url, "Redação")
        .then(result => {
          let editor = document.getElementsByClassName("tui-image-editor-size-wrap")[0];
          let wrapper = document.getElementsByClassName("tui-image-editor-container")[0];

          let newWidth = editor.offsetWidth * this.editorMaxSizePercentage;

          this.width = newWidth;
          this.maxWidth = editor.offsetWidth;
          this.height = (result.newHeight / result.newWidth) * newWidth;

          wrapper.style.height = `${this.height + 50 + 65 + 25 + 10}px`;

          this.$refs.tuiImageEditor.invoke("ui.resizeEditor", {
            imageSize: {
              newWidth: this.width,
              newHeight: this.height
            }
          });
          this.carregandoRedacao = false;
        });
    },
    CreateCorrecao(correcao) {
      this.correcao.video = localStorage.getItem("videourl");
      CorrecaoService.Create(correcao).then(() => {
        this.$buefy.toast.open({
          duration: 5000,
          message: "Correção criada com sucesso!",
          position: "is-top-right",
          type: "is-success"
        });
        
        this.LiberarCorrecao();
        localStorage.removeItem("videourl");
        localStorage.setItem("videourl", "");
        this.$router.push({ name: 'redacao'});
      });
    },
    RecordStart() {
      //disable, eneable buttons
      document.getElementById("btn-start-recording").disabled = true;
      document.getElementById("btn-stop-recording").disabled = false;
      document
        .getElementsByClassName("mycontainer zeromp")[0]
        .classList.add("gravando");

      Record.startRecording();
    },
    RecordStop() {
      //disable, eneable buttons

      document
        .getElementsByClassName("mycontainer zeromp")[0]
        .classList.remove("gravando");
      document.getElementById("btn-start-recording").disabled = false;
      document.getElementById("btn-stop-recording").disabled = true;
      Record.stopRecording(function (progress) {
          this.percentProgress = Math.floor(progress);
          if(this.percentProgress == 100){
            document.getElementById("updatebutton").disabled = false;
          }
      }.bind(this));
    },
    LiberarCorrecao(toast=false){

      if (!this.corrigindo) return;
      //alert();
      RedacaoService.LiberarCorrecao(this.$route.params.uuid).then(()=>{
        if(toast){
          this.$buefy.toast.open({
            duration: 5000,
            message: "Redação liberada de volta para a fila",
            position: "is-top-right",
            type: "is-success"
          }); // buefy toast
        }
      });
      window.removeEventListener("beforeunload", this.beforeUnload);
      window.removeEventListener("unload", this.unload);
      this.corrigindo = false;
    },
    beforeUnload(e) {
      //alert("before unload");
      if(e) {
        e.preventDefault();
        e.returnValue = ''; 
      }
      this.LiberarCorrecao(true);
    },
    unload() {
      //alert("unload");
      this.LiberarCorrecao(true);
    }
  },
  computed: {
    isDisabled: function() {
      return false;
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.beforeUnload)
    window.addEventListener("unload", this.unload);
    window.addEventListener("scroll", this.scrollHandler);      
    //
    this.corrigindo = true;
    //
    RedacaoService.Corrigindo(this.$route.params.uuid, store.getters.cargo_id).then(result => {
      if(result.data != null){
        this.corrigindo = true;
        this.redacao = result.data;
        this.correcao.redacao_id = this.redacao.id;
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    //alert("route leave");
    if (this.corrigindo) {
      if (!window.confirm(
        "Você deseja cancelar esta correção e liberar a " +
        "redação de volta para a fila de corrigir? Os dados atuais desta página serão perdidos"
        )) {
        return;
      }
      this.LiberarCorrecao(true);
    }
    next();
  },
};
</script>
<style>
.tui-image-editor-submenu {
    width: 40px !important;
}
.tui-image-editor-submenu-style{
  display: none !important;
}
.tui-image-editor-container .tui-image-editor-controls {
  background-color: #fffbef;
}
.tui-image-editor-controls-buttons button {
  display: none !important;
}
</style>